module.exports = __webpack_public_path__ + "static/media/new_reservation.f7a88fc8.svg";